<template>
    <div>
        <h6 class="heading-small text-muted mb-4">ข้อมูลการชำระเงิน</h6>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ประเภทการชำระเงิน
                    </label>
                    <v-select
                        :disabled="disablePayment"
                        label="title"
                        :options="listPaymentType"
                        v-model="personal.paymentType"
                        :reduce="paymentType => paymentType.key"
                        @input="setPaymentType"
                    >
                    </v-select>
                </div>
            </div>
            <div class="col-lg-6" v-if="!['CREDIT_SHIPPOP'].includes(personal.paymentType)">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> เงื่อนไขประเภทการชำระเงิน
                    </label>
                    <v-select
                        :disabled="disablePayment" 
                        label="title"
                        :options="listPaymentCondition[personal.paymentType]"
                        :reduce="paymentCondition => paymentCondition.key"
                        v-model="personal.paymentCondition"
                    >
                    </v-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        personal: Object,
        disablePayment: Boolean
    },
    data(){
        return{
            listPaymentType:[
                { key: 'CREDIT_SHIPPOP' , title: 'วางบิลโดยระบบ Business' },
                { key: 'PREPAID' , title: 'ชำระเงินทันที'},
                { key: 'MONTHLY' , title: 'รายเดือน'},
                { key: 'DAILY' , title: 'รายวัน'},
                { key: 'WEEKLY' , title: 'รายสัปดาห์'},
            ],
            listPaymentCondition:{
                PREPAID:[
                    { key: null , title: 'ชำระทันที'},
                ],
                DAILY:[
                    { key: '0' , title: 'ชำระทุกวัน ไม่เกิน 15:00 น.'},
                ],
                WEEKLY:[
                    { key: '0' , title: 'ชำระทุกวันจันทร์'},
                    { key: '1' , title: 'ชำระทุกวันอังคาร'},
                    { key: '2' , title: 'ชำระทุกวันพุธ'},
                    { key: '3' , title: 'ชำระทุกวันพฤหัส'},
                    { key: '4' , title: 'ชำระทุกวันศุกร์'},
                    { key: '6' , title: 'ชำระสัปดาห์ถัดไป (กรณีพิเศษ)'},
                ],
                MONTHLY:[
                    { key: 'SEVEN_OF_MONTH' , title: 'ชำระภายใน 7 วัน'},
                    { key: 'TWENTYFIVE_OF_MONTH' , title: 'ชำระได้ไม่เกินวันที่ 25 ของเดือน'},
                    { key: 'END_OF_MONTH' , title: 'ชำระไม่เกินสิ้นเดือน'},
                ]
            }
        }
    },
    methods: {
        setPaymentType( paymentType ){
            if( ['CREDIT_SHIPPOP'].includes(this.personal.paymentType) ){
                this.personal.paymentCondition = ''
                this.$emit( 'setWallet' , false )
            }else{
                this.personal.paymentCondition = this.listPaymentCondition[paymentType][0].key
                this.$emit( 'setWallet' , true )
            }
        },
    },
}
</script>